import "acf-maps.js"
import "flickity/flickity-min.js"
import swal from "sweetalert/package/src/sweetalert2.js"

window.Swal = swal;

( function( $ ) {
   
  ///// MOBILE NAV /////
  $(document).on('click', '.js-navModal-toggle', function() {
    $(this).toggleClass('-open');
    $('body, .js-header').toggleClass('-navModal-open');
    $('.js-navModal').toggleClass('-collapsed');
  });
  
  ///// HEADER SCROLL /////
  var header = $(".js-header");
  var scrollTop = 0;
  
  $(window).on('scroll load', function() {	  
	  scrollTop = $(this).scrollTop();	  
	  if (scrollTop > 30) {
		  header.addClass('-scrolled');
	  } else {
		  header.removeClass('-scrolled');
	  }	  
  });
	
	///// FLICKITY /////
	$('.js-carousel').flickity({
		cellAlign: 'left',
	 	cellSelector: '.js-carousel-item',
	  watchCSS: true,
	  pageDots: false,
	  prevNextButtons: false,
	  contain:false,
	});
  
  ///// VIDEOMODAL /////
  $('.js-close-videoModal').on('click', function() {
	  $('body').removeClass('-videoModal-open');
	  $('.js-videoModal').fadeOut(500, function() {
		  $(this).remove();
		});
	  
	  // Set cookie
	  document.cookie = "videoModalShown=1;max-age=3600";
  });
  
  
  ///// LEAVE MEMBERS PAGE /////
  $('.js-leave-members').on('click', function(e) {
	  var targetHref = $(this).find('a').attr('href');
	  console.log(targetHref);
	  e.preventDefault();
	  Swal.fire({
		  title: 'Weet je het zeker?',
		  text: 'Als je doorgaat, verlaat je het ledendeel van de lustrumwebsite. Je kunt altijd weer terug via menukop \'Leden\'.',
		  icon: false,
		  showConfirmButton: true,
		  showCancelButton: true,
		  confirmButtonText: 'Verlaat pagina',
		  cancelButtonText: 'Blijf op pagina'
		}).then((result) => {
			if (!result.dismiss) {
				window.location.href = targetHref;
			}
		})
  });
  
  ///// PASSE-PARTOUTS TOGGLE /////
  var changeTimeOut;
  var animationTimeOut;
  $('.js-pp-toggle').change(function(e) {
	  var toggle = $(this);
	  var regularPrice = $('.js-pp-regularPrice');
	  var discountPrice = $('.js-pp-discountPrice');
	  var priceWrapper = $('.js-pp-priceWrapper');
	  
	  toggle.attr('disabled', 'disabled');
	  
	  priceWrapper.addClass('-changed');
	  clearTimeout(animationTimeOut);
	  
	  changeTimeOut = setTimeout(function() {
	  if (e.target.checked) {
		  regularPrice.hide();
		  discountPrice.show();
	  } else {
		  regularPrice.show();
		  discountPrice.hide();
	  }
	  }, 250);
	  	 
	  animationTimeOut = setTimeout(function() {
		  priceWrapper.removeClass('-changed');
		  toggle.attr('disabled', false);
	  }, 500);
  });
  
  
  
  ///// FAQ TOGGLE /////
  $('.js-faq-item-toggle').on('click', function() {
	  var parent = $(this).parent('.js-faq-item');
	  var openToggle = !parent.hasClass('-active');
	  $('.js-faq-item.-active .js-faq-item-answer').stop().slideUp(200);
	  $('.js-faq-item.-active').removeClass('-active');
	  
	  if (openToggle) {
		  $(this).next('.js-faq-item-answer').stop().slideDown(200);
		  parent.addClass('-active');
	  }
  });
  
  
  ////// SMOOTH SCROLL /////
  $(".js-smooth-scroll").click(function() {
	  var target = $('#' + $(this).data('target'));
	  var offset = $(".js-header").outerHeight() + 30;
	  
	  $('html, body').animate({
      scrollTop: target.offset().top - offset
    }, 500, function() {
      // Callback after animation
      // Must change focus!
      var $target = $(target);
      $target.focus();
      
    });
    
  });
  
  //---------------------------//
	// OPEN EXTERNAL LINKS IN NEW TAB
	//---------------------------//
/*
  $.expr[':'].external = function(obj) {
      return (!obj.href.match(/^mailto\:/) && (obj.hostname !== location.hostname) && !obj.href.match(/^javascript\:/) && !obj.href.match(/^$/));
  };
		
  $("a[href$='pdf']").attr('target', '_blank');
  $("a[href$='doc']").attr('target', '_blank');
  $("a[href$='docx']").attr('target', '_blank');
  $('a:external').attr('target', '_blank');
*/


  
} )( jQuery );